import { UseQueryResult, useQuery } from '@tanstack/react-query'

import { ClientLocationPetProfileService } from '../services/client_location_pet_profile.service'
import { APILocationPetProfileClientDtoResponse, LocationPetProfileClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientLocationPetProfile = (
  locationName: string,
  lupId: string,
  lppId: string,
  includes?: string[]
): UseQueryResult<LocationPetProfileClientDto> => {
  return useQuery<LocationPetProfileClientDto>({
    queryKey: ['clientLocationUserProfile', locationName, lupId, lppId],
    queryFn: () => ClientLocationPetProfileService.get(locationName, lupId, lppId, includes),
    ...defaultQueryOptions,
  })
}

export const useClientLocationPetProfiles = (
  locationName: string,
  lupId?: string,
  includes?: string[]
): UseQueryResult<APILocationPetProfileClientDtoResponse> => {
  return useQuery<APILocationPetProfileClientDtoResponse>({
    queryKey: ['clientLocationUserProfiles', locationName, lupId],
    queryFn: () => ClientLocationPetProfileService.list(locationName, lupId || '', includes),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}
